/** Read-only compatibility for saved registry tabs. New writes use Workroom addresses. */
export function normalizeStoredWorkroomBoardAddress(address: string): string {
  return address === "skill-rooms" ? "workrooms" : address;
}
